import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  root: ({ colors }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.brand.primary[500]};
  `,
})

export default useStyles
